// @vendors
import  { useMemo, useState } from 'react'

// @services
import PayrollService from '../../../services/newApi/PayrollService';
 
// @context
import { useUI } from '../../../app/context/ui';

// @helpers
import AppHelper from '../../../helpers/AppHelper';

const usePayroll = () => {
    const { blockUI, snackbarUI } = useUI();
    const payrollService = useMemo(() => new PayrollService(), []);
    const [certificationGroups, setCertificationGroups] = useState([])

    const getCertificationTargetGroups = async () => {
    try {
        blockUI.current.open(true);
        const response = await payrollService.fetchCertificationTargetGroups(true);
        setCertificationGroups(response?.data?.data || []);
        blockUI.current.open(false);
    } catch (error) {
        blockUI.current.open(false);
        AppHelper.checkError(error, snackbarUI);
    }
  } 


  const createTargetGroup = async (body) => {
    try {
      blockUI.current.open(true);
      const response = await payrollService.createTargetGroup(body);
      await getCertificationTargetGroups();
      blockUI.current.open(false);
      return response?.data?.data ?? response?.data ?? true;
    } catch (error) {
      blockUI.current.open(false);
      AppHelper.checkError(error, snackbarUI);
      return false;
    }
  }

  return {
    certificationGroups,
    getCertificationTargetGroups,
    createTargetGroup
  }
}

export default usePayroll